import { getToDay } from '@/utils/date';
import moment from 'moment';

const [startDate, endDate] = getToDay()
const params = {
  orderKey: '',
  orderValue: '',

  startDate: moment(startDate).add(-3, 'days').format('YYYY-MM-DD 00:00:00'),
  endDate: moment(endDate).format('YYYY-MM-DD 23:59:59'),

  querDate: {}
  // startDate: moment('1999-04-28 16:25:21'),
};
export default {
  namespace: 'centerinfo',
  state: {
    value: [],
    arrived: [],
    searchParams: { ...params },

    dataList: []
  },

  effects: {
    // *getData({ payload }, { put, select }) {
    //   const { searchParams, datadbName } = yield select(({ centerinfo }) => centerinfo);
    //   const DataSourceApiUrl = { druid: '/api/routeSr/selectStatistic', dorisdb: '/api/forecastdoris/statistic' }
    //   const inFilters=[]
    //     if (searchParams.orderValue) {
    //       inFilters.push({ key: searchParams.orderKey, value: searchParams.orderValue.split(',') });
    //     }

    //   const params = {
    //     ...payload.params,
    //     inFilters,
    //     startDate: searchParams.startDate,
    //     endDate: searchParams.endDate
    //   }

    //   const data = yield crudRequest(DataSourceApiUrl[datadbName], params)
    //   console.log('data',data)
    //   if (data && data.code === 1) {
    //     yield put({ type: effectName, payload: { data: JSON.parse(data.data) || [], dsIndex: index } });
    //   }
    // },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    searchParamsUpdate(state, { payload }) {
      const searchParams = { ...state.searchParams, ...payload };
      return { ...state, searchParams };
    },
    resetSearchParam(state) {
      return { ...state, searchParams: { ...params } };
    },
  },
};
